

import React, { memo, useCallback, useEffect, useRef } from 'react';
import InfiniteScrollComponent from 'react-infinite-scroll-component';
import _isFunction from 'lodash.isfunction';
import Loader from '../../Loader';

import '../styles/infinite-scroll.scss';










export const COUNT_NO_DATA = 0;
export const NO_MORE_OUTERDIV_CLASS = 'infinite-scroll-component__outerdiv--no-more';

const InfiniteScroll = ({
  count = COUNT_NO_DATA,
  loader = <Loader hasNoBeforeShowTimeout />,
  data = [],
  getScrollableTarget: getScrollableTargetProp,
  onLoadMore,
  children
}) => {
  const ref = useRef();

  const dataLength = Array.isArray(data) ? data.length : COUNT_NO_DATA;
  const hasMore = dataLength < count;

  // Issue with infinite scroll
  // When elements height is smaller than screen height
  // Lib adds screen height to wrapper and we have a lot of empty space
  useEffect(() => {
    /* istanbul ignore next */
    if (!ref.current) {
      return;
    }

    const infiniteScrollEl = ref.current._infScroll;
    const outerInfiniteScrollEl = infiniteScrollEl.parentElement;

    if (hasMore) {
      outerInfiniteScrollEl.classList.remove(NO_MORE_OUTERDIV_CLASS);
    } else {
      outerInfiniteScrollEl.classList.add(NO_MORE_OUTERDIV_CLASS);
    }
  }, [hasMore]);

  const getScrollableTarget = useCallback(() => {
    if (_isFunction(getScrollableTargetProp)) {
      // $FlowFixMe
      return getScrollableTargetProp();
    }

    return getScrollableTargetProp;
  }, [getScrollableTargetProp]);

  // When the browser is zoomed out, infinite scroll can break in two ways:
  // 1. Content doesn't fill the container — no scrollbar, no scroll events, next() never fires.
  // 2. User is already at/near the bottom after new items load — no new scroll event fires
  //    because scroll position hasn't changed, so the library never re-evaluates.
  // This effect runs after each data change and triggers onLoadMore if either case is detected.
  useEffect(() => {
    if (!hasMore) {
      return () => {};
    }

    const getScrollElement = () => {
      const scrollTarget = getScrollableTarget();

      if (scrollTarget instanceof HTMLElement) {
        return scrollTarget;
      }

      if (ref.current && ref.current._infScroll) {
        return ref.current._infScroll.parentElement;
      }

      return null;
    };

    const checkShouldLoadMore = () => {
      const el = getScrollElement();

      if (!el) {
        return;
      }

      const contentDoesNotFillContainer = el.scrollHeight <= el.clientHeight;
      const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;

      if (contentDoesNotFillContainer || isAtBottom) {
        onLoadMore();
      }
    };

    const timerId = setTimeout(checkShouldLoadMore, 200);

    return () => clearTimeout(timerId);
  }, [hasMore, dataLength, getScrollableTarget, onLoadMore]);

  return (
    <InfiniteScrollComponent
      ref={ref}
      scrollableTarget={getScrollableTarget()}
      hasMore={hasMore}
      loader={loader}
      dataLength={dataLength}
      next={onLoadMore}>

      {children}
    </InfiniteScrollComponent>);

};

export default memo(InfiniteScroll);